<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('HorizontalLineTool', function() {
            return {
                // Descriptor for the tool
                group: 'Lines', category: 'Lines', icon: this.getIcon('horizontal_line'),
                type: 'Segment',
                name: 'Horizontal Line',
                hint: 'This hint will be shown on hover',
                data: [],     // Default data
                settings: {}, // Default settings
                mods: {
                    'Ray': {
                        // Rewrites the default setting fields
                        settings: { ray: true },
                        category: 'Lines',
                        icon: this.getIcon('horizontal_ray'),
                        name: 'Horizontal Ray'
                    },
                    'Arrow': {
                        // Rewrites the default setting fields
                        settings: { arrow: true },
                        category: 'Lines',
                        icon: this.getIcon('arrow'),
                        name: 'Horizontal Arrow'
                    }
                }
            }
        }, s => s.ray ? 'Horizontal Ray' : s.arrow ? 'Horizontal Arrow' : 'Horizontal Line')
</script>
